import { BancoAgEntidade, ContribuicaoIndividualEntidade, DependenteEntidade, EstadoCivilEntidade, FileUploadEntidade, PaisEntidade, SexoEntidade, UFEntidade, WebRecadDadosConclusaoEntidade, WebRecadParticipanteDadosEntidade, WebRecadPublicoAlvoEntidade } from "@entidades";
import * as ReactService from "@intech/react-service";

class Recadastramento extends ReactService.BaseService {
  constructor() {
    super("Recadastramento");
  }

  Upload = (Arquivo: FileUploadEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Upload`, Arquivo);

  BuscarPorCpf = () =>
    this.CreateRequest<WebRecadPublicoAlvoEntidade[]>(ReactService.RequestType.GET, `BuscarPorCpf`);

  BuscarDadosPorCpf = (oid: number) =>
    this.CreateRequest<WebRecadParticipanteDadosEntidade>(ReactService.RequestType.GET, `BuscarDadosPorCpf/${oid}`);

  BuscarPassosDisponiveis = (oid: number) =>
    this.CreateRequest<number[]>(ReactService.RequestType.GET, `BuscarPassosDisponiveis/${oid}`);

  BuscarDependentes = (cdPlano: string) =>
    this.CreateRequest<DependenteEntidade[]>(ReactService.RequestType.GET, `BuscarDependentes/${cdPlano}`);

  BuscarBeneficiarios = (cdPlano: string) =>
    this.CreateRequest<DependenteEntidade[]>(ReactService.RequestType.GET, `BuscarBeneficiarios/${cdPlano}`);

  BuscarContribPensao = () =>
    this.CreateRequest<ContribuicaoIndividualEntidade[]>(ReactService.RequestType.GET, `BuscarContribPensao`);

  ValidarEmail = (email: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarEmail/${email}`);

  ValidarCpf = (cpf: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarCpf/${cpf}`);

  ValidarDataEmissao = (dataEmissao: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarDataEmissao/${dataEmissao}`);

  BuscarListaEstadoCivil = () =>
    this.CreateRequest<EstadoCivilEntidade[]>(ReactService.RequestType.GET, `BuscarListaEstadoCivil`);

  BuscarEstadoCivil = (CdEstadoCivil: string) =>
    this.CreateRequest<EstadoCivilEntidade>(ReactService.RequestType.GET, `BuscarEstadoCivil/${CdEstadoCivil}`);

  BuscarListaUF = () =>
    this.CreateRequest<UFEntidade[]>(ReactService.RequestType.GET, `BuscarListaUF`);

  BuscarUF = (CdUF: string) =>
    this.CreateRequest<UFEntidade>(ReactService.RequestType.GET, `BuscarUF/${CdUF}`);

  BuscarListaPais = () =>
    this.CreateRequest<PaisEntidade[]>(ReactService.RequestType.GET, `BuscarListaPais`);

  BuscarPais = (CdPais: string) =>
    this.CreateRequest<PaisEntidade>(ReactService.RequestType.GET, `BuscarPais/${CdPais}`);

  BuscarListaSexo = () =>
    this.CreateRequest<SexoEntidade[]>(ReactService.RequestType.GET, `BuscarListaSexo`);

  BuscarListaBanco = () =>
    this.CreateRequest<BancoAgEntidade[]>(ReactService.RequestType.GET, `BuscarListaBanco`);

  Concluir = (Dados: WebRecadDadosConclusaoEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Concluir`, Dados);

  EnviarToken = (enviarSms: boolean, enviarEmail: boolean, alvoEnvio: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `EnviarToken/${enviarSms}/${enviarEmail}/${alvoEnvio}`);

}

export const RecadastramentoService = new Recadastramento();
